import { Component, Input, Output, EventEmitter } from '@angular/core';
import {BasketArticleDto} from '@shared/service-proxies/service-proxies';
import _ from 'lodash';

@Component({
    selector: 'app-quick-add',
    templateUrl: './quick-add.component.html',
    styleUrls: ['./quick-add.component.less']
})
export class QuickAddComponent {
    @Input() label = 'Add to cart in one click and go next:';
    @Input() quickAddAmounts: number[] = [];

    @Input() article: BasketArticleDto;

    @Output()
    onQuickAction: EventEmitter<BasketArticleDto> = new EventEmitter();

    onQuickAdd(amount: number): void {
        let article = _.cloneDeep(this.article);
        if (article) {
            article.quantity = amount;
        }

        this.onQuickAction.emit(article);
    }
}
